import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a0a64f5a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a64f5a')) {
      api.createRecord('a0a64f5a', component.options)
    } else {
      api.reload('a0a64f5a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=a0a64f5a", function () {
      api.rerender('a0a64f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/subscription/Index.vue"
export default component.exports